import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Icon, List } from '@pella/sash-framework';

import SwatchesPanel from '../swatches-panel';
import InterstackFNO from '../../../common/interstack-fno';
import ScreensPanel from '../screens-panel';
import ImagePanel from '../image-panel';

const FNOTabs = ({ data, ...other }) => {
	const [activeTab, setActiveTab] = useState(0);

	if (!data) return null;

	const onTabClick = (index) => setActiveTab(index);
	const onAccordionClick = (index) => setActiveTab(activeTab === index ? null : index);

	return (
		<div
			id={data.anchor_text}
			className='fnoTabs bg-gray-5 py-8 xl:py-12'
			{...other}
		>
			<Container>
				{data.heading && <h2 className='mb-6 text-center font-normal xl:mb-10'>{data.heading}</h2>}

				<div className='fnoTabs-tabsWrapper lg:border lg:border-gray-20 lg:shadow-md'>
					<List
						bullets='none'
						className='fnoTabs-tabs divide-x-gray-30 hidden divide-x bg-gray-20 lg:flex'
					>
						{data.options_tabs.map((tab, index) => (
							<li
								key={index}
								className='flex-1 text-center text-base md:text-lg'
							>
								<button
									className={`block w-full border-0 border-t-4 px-0 pb-5 pt-4 font-semibold ${activeTab === index ? 'active-tab border-t-primary bg-white text-black' : 'border-t-transparent bg-gray-15 text-gray-50 hover:text-gray-70 focus:text-gray-70'}`}
									onClick={() => onTabClick(index)}
								>
									<span className='block truncate px-2.5'>{tab.tab_name}</span>
								</button>
							</li>
						))}
					</List>

					<div className='fnoTabs-tabPanels bg-white'>
						{data.options_tabs.map((panels, index) => (
							<div key={index}>
								<button
									onClick={() => onAccordionClick(index)}
									className={`fnoTabs-accordionBtn relative block w-full border-0 bg-secondary p-2.5 text-lg uppercase tracking-3px text-white sm:text-xl lg:hidden ${activeTab === index ? 'active-accordion' : ''} ${data.options_tabs.length - 1 !== index ? 'border-b-2 border-b-white' : ''}`}
								>
									<span>{panels.tab_name}</span>
									<Icon
										name={activeTab === index ? 'expand_less' : 'expand_more'}
										className='absolute right-2 top-1/2 -mt-5'
										size={40}
									/>
								</button>

								<div className={`fnoTabs-tabPanel p-5 sm:p-8 ${activeTab !== index ? 'hidden' : ''}`}>
									{panels.tab_content && (
										<div
											dangerouslySetInnerHTML={{ __html: panels.tab_content }}
											className='fnoTabs-tabPanelIntro'
										/>
									)}

									{panels.internal_fno?.[0]?.swatches?.[0] && <SwatchesPanel data={panels.internal_fno} />}

									{panels.internal_fno?.[0]?.special_fno?.fno_layout === 'screens' && panels.internal_fno[0].special_fno.card?.[0] && <ScreensPanel data={panels.internal_fno[0].special_fno} />}

									{panels.internal_fno?.[0]?.special_fno?.fno_layout === 'insynctive' && panels.internal_fno[0].special_fno.card?.[0] && <ImagePanel data={panels.internal_fno[0].special_fno.card[0]} />}

									{panels.interstack?.[0] && <InterstackFNO data={panels.interstack} />}
								</div>
							</div>
						))}
					</div>
				</div>
			</Container>
		</div>
	);
};

FNOTabs.propTypes = {
	data: PropTypes.object,
};

export default FNOTabs;
